import React from 'react';

const STATE_ICONS = {
  'queued': 'clock-o',
  'open': 'circle-o',
  'resolved': 'check-circle-o',
  'verified': 'check-circle',
  'closed': 'lock',
  'notice': 'info-circle',
  'rejected': 'times-circle'
};

const CaseStateBadge = ({ state }) => {

  const icon = STATE_ICONS[state];

  return (
    <span
      className={`state-badge state-badge--${state} case-state-badge`}
    >
      { icon ? <span className={`fa fa-fw fa-${icon}`} /> : null }
      <span className="state-badge-text">
        {state}
      </span>
    </span>
  );
};

const CommentSnippets = ({ commentsText, query }) => {
  let matches = [];
  let queryIndices = [];
  const nBufferChars = 20;
  commentsText.forEach((comment) => {
    const indicesOfQuery = indicesOfAllMatches(comment, query)
    if (indicesOfQuery.length > 0) {
      indicesOfQuery.forEach((indexOfQuery) => {
        const snippetStart = Math.max(indexOfQuery - nBufferChars, 0);
        let commentSlice = comment.slice(snippetStart, comment.length);
        let queryIndex = Math.min(nBufferChars, indexOfQuery);
        if (snippetStart !== 0) {
          commentSlice = "..." + commentSlice;
          queryIndex += 3;
        }
        matches.push(commentSlice);
        queryIndices.push(queryIndex);
      })
    }
  })
  const nMatches = matches.length;
  const nToDisplay = 5;
  const nHidden = nMatches - nToDisplay;

  if (nMatches > 0) {
    return (
      <>
        { matches.slice(0, nToDisplay).map((match, index) => {
          return (
            <div key={`match-${index}`} className="comment-snippet smallish">
              <i className="fa fa-comment-o mr-2" title="Comment"></i>
              {match.slice(0, queryIndices[index])}
              <span className="highlighted">
                {match.slice(queryIndices[index], queryIndices[index] + query.length)}
              </span>
              {match.slice(queryIndices[index] + query.length, match.length)}
            </div>
          )
        })}
        { nMatches > nToDisplay ?
          <span className="smallish text-muted">
            {nHidden} more match{nHidden === 1 ? '' : 'es'} in comments
          </span> : null
        }
      </>
    )
  } else {
    return null;
  }
}

function indicesOfAllMatches(comment, query) {
  let i = 0;
  let matchIndices = [];
  while (true) {
    const matchIndex = comment.toLowerCase().indexOf(query.toLowerCase(), i);
    if (matchIndex !== -1) {
      matchIndices.push(matchIndex);
      i = matchIndex + 1;
    } else {
      return matchIndices;
    }
  }
};

export default ({ fields, query }) => (
  <span className='related-links'>
    <span className="display-id-wrapper">
      <span className="fa fa-fw fa-clipboard mr-2" />
      <span className="display-id">
        {fields['display_id']}
      </span>
      <CaseStateBadge state={fields['state']} />
    </span>
    <span className="subject">
      {fields['subject']}
    </span>
    <br/>
    <span>
      <CommentSnippets
        commentsText={fields['comments_text'] || []}
        query={query}
      />
    </span>
  </span>
);
